import { create } from "zustand";
import type { WsStatus } from "@/shared/api/ws";

/**
 * 조직 경보 WebSocket(`/ws/org/<id>/alerts`)이 지금 살아 있는가 — 경보 폴링 간격을 정하는 신호(2026-10-19, 10-12 검증 V-31).
 *
 * 경보 목록은 WS 의 `alert.fired`·`alert.cleared` 로 즉시 갱신되고, 30초 폴링은 WS 가 끊겼을 때의 보조 경로다.
 * 그런데 WS 가 끊겨도 폴링은 30초 그대로였다 — 끊긴 동안 새 경보를 최대 30초 늦게 봤다. 끊긴 동안만 간격을 줄인다
 * (`shared/api/hooks/alerts.ts`). 상태는 AppShell 에 늘 떠 있는 AlertTtsAnnouncer 가 구독 결과를 적는다.
 *
 * null = 모름(로그인 전·조직 없음) → 평소 간격.
 */
interface AlertLinkState {
  wsStatus: WsStatus | null;
  /** 한 번이라도 연결을 시도했나 — 구독 직전의 초기값 "closed" 를 끊김으로 세지 않으려고. */
  attempted: boolean;
  setWsStatus: (s: WsStatus | null) => void;
}

export const useAlertLinkStore = create<AlertLinkState>()((set) => ({
  wsStatus: null,
  attempted: false,
  setWsStatus: (wsStatus) =>
    set((prev) => ({
      wsStatus,
      attempted: wsStatus == null ? false : prev.attempted || wsStatus !== "closed",
    })),
}));

/** 경보 WS 가 끊긴 상태인가(재접속 중이거나, 연결을 시도한 뒤 닫힘). */
export function isAlertWsDown(s: Pick<AlertLinkState, "wsStatus" | "attempted">): boolean {
  if (s.wsStatus === "reconnecting") return true;
  return s.wsStatus === "closed" && s.attempted;
}
